/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ExternalImportRemoval} from '../../../_models/external-import-removal';
import {RemovalImportType} from '../../../_forms/removal-import-type';
import {ExternalImportAnimal} from '../../../_models/external-import-animal';
import {AnimalImportType} from '../../../_forms/animal-import-type';
import {ToolsHelper} from '../../../_helpers/tools-helper';

@Component({
  selector: 'app-display-animals-not-added',
  templateUrl: './display-animals-not-added.component.html',
  styleUrls: ['./display-animals-not-added.component.scss']
})
export class DisplayAnimalsNotAddedComponent implements OnInit, OnChanges {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() externalRemoval: ExternalImportRemoval;
  @Input() submittedRemoval: RemovalImportType;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public data: AnimalImportType[] = [];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    this.findNotAddedAnimals();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.findNotAddedAnimals();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private externalAnimalExistByNumber(n: string): boolean {
    return (0 < this.externalRemoval.animals.filter((a: ExternalImportAnimal) => a.number === n).length);
  }

  private findNotAddedAnimals() {
    this.data = [];

    if (this.externalRemoval && this.submittedRemoval) {
      this.submittedRemoval.animals.forEach((sa: AnimalImportType) => {
        if (ToolsHelper.isValidAnimalNumber(sa.number) && !this.externalAnimalExistByNumber(sa.number)) {
          this.data.push(JSON.parse(JSON.stringify(sa)));
        }
      });
    }
  }

}
